import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fecharCompetencia } from '../api/FechamentoApi';
import type { FechamentoCompetenciaPayload, FecharAbrirCompetenciaResponse } from '../api/types';

export function useFecharCompetencia() {
  const queryClient = useQueryClient();

  return useMutation<FecharAbrirCompetenciaResponse, Error, FechamentoCompetenciaPayload>({
    mutationFn: fecharCompetencia,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['status-fechamento-snac'] });
    },
  });
}
